module.exports = __webpack_public_path__ + "static/media/checkoutTransactions.e69f2e6c.svg";